"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Fullscreen(_a) {
    var children = _a.children, returnUrl = _a.returnUrl, className = _a.className, onClick = _a.onClick;
    var Component = returnUrl ? storybook_1.Buttons.Link : storybook_1.Buttons.Button;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-layouts-fullscreen', className) },
        react_1.default.createElement(Component, { to: "" + process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + returnUrl, onClick: onClick, className: 'storybook-layouts-fullscreen-close' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'x', className: 'w-6 h-6' })),
        children);
}
exports.default = Fullscreen;
